'use es6';

const SortDirections = {
  ASCENDING: 1,
  DESCENDING: -1,
  NONE: 0
};
export const UITableSortDirections = {
  ascending: SortDirections.ASCENDING,
  descending: SortDirections.DESCENDING,
  none: SortDirections.NONE
};
export const getSortDirectionAsString = sortDir => {
  if (sortDir === SortDirections.ASCENDING) {
    return 'ascending';
  } else if (sortDir === SortDirections.DESCENDING) {
    return 'descending';
  }

  return 'none';
};
export default SortDirections;